import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { EmployeeService } from '../../services/employee.service';

@Component({
    selector: 'app-employees',
    templateUrl: './employees.component.html',
    styleUrls: ['./employees.component.scss'],
    standalone: false
})
export class EmployeesComponent implements OnInit {

  employees: any[] = [];
  showloader = true;
  crumbList: any[];

  constructor(
    public userSer: UserService,
    private employeeSer: EmployeeService) {
  }

  ngOnInit() {
    this.crumbList = [
      { title: 'Home', url: '/dashboard' }
    ];

    const userData = this.userSer.getUserData();
    const clientId = userData && userData.client ? userData.client.ID : (userData ? userData.ClientID : null);

    if (!clientId) {
      this.showloader = false;
      return;
    }

    this.employeeSer.getEmployees(clientId).subscribe({
      next: (res: any) => {
        this.employees = res.data || [];
        this.showloader = false;
      },
      error: () => {
        this.showloader = false;
      }
    });
  }

}
